import React from 'react';
import { Button } from 'react-bootstrap';
import { getTenantFromToken } from 'utils/routeUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';

/**
 * ExportButton — Standalone button that navigates to the Export Farmland Report screen in a new tab.
 */
const ExportButton = () => {
  const tenant = getTenantFromToken();

  const handleNavigation = () => {
    // Navigate to the export history screen in a new tab
    const url = `/${tenant}/exportFarmlandReport`;
    window.open(url, '_blank');
  };

  return (
    <Button
      id="farmland-report-export-btn"
      variant="primary"
      size="sm"
      onClick={handleNavigation}
      className="me-2 shadow-sm d-flex align-items-center"
      style={{
        whiteSpace: 'nowrap',
        borderRadius: '0.5rem',
        fontWeight: '600',
        padding: '0.4rem 1rem',
        transition: 'all 0.2s ease-in-out'
      }}
    >
      <FontAwesomeIcon icon={faFileExport} className="me-2" />
      Export
    </Button>
  );
};

export default ExportButton;
